import React, { useMemo } from 'react';
import RichText from '../rich-text';
import type { PrismicSliceCategories } from 'src/types';
import { Link } from 'react-router-dom';
import type { FacetLink } from 'src/areas/product-collection/components/navigation/types';
import {
  VisualNavigation,
  VisualNavigationLink,
} from '@prisjakt/ui/visual-navigation';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { useAppContext } from 'src/components/app-context';

type Props = Pick<PrismicSliceCategories, 'optionalTitle' | 'categories'>;

const Categories = ({ optionalTitle, categories }: Props) => {
  const { market, linkTo } = useAppContext();

  const formattedLinks: FacetLink[] = useMemo(
    () =>
      categories
        ?.filter(category => category !== null)
        .map(category => {
          const link: FacetLink = {
            id: category?.id || '',
            value: category?.name || '',
            selected: false,
            path:
              category?.type === 'classic' && market.useClassicUrls
                ? linkTo('category', category)
                : category?.path,
            imageUrl: category?.image || category?.fallbackImage,
            indexable: true,
          };
          return link;
        }) ?? [],
    [categories, linkTo, market.useClassicUrls]
  );

  if (!categories) return null;

  return (
    <>
      {optionalTitle && <RichText data={optionalTitle} />}
      <VisualNavigation linksPerRow={4} compact>
        {formattedLinks.map((link, index) => (
          <VisualNavigationLink
            key={link.id}
            label={link.value}
            imageSrc={link.imageUrl || ''}
            imageAlt={link.value}
            containerProps={{
              title: link.value,
            }}
            linkContainer={Link}
            linkContainerProps={{
              to: link.path,
              onClick: () => {
                if (link.path) {
                  trackInternalNavigationClick({
                    scope: InternalNavigationScope.CATEGORY_CARD,
                    nextPage: link.path,
                    index,
                  });
                }
              },
            }}
          />
        ))}
      </VisualNavigation>
    </>
  );
};

export default Categories;
/*

      
*/
